
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import StoryHero from './components/StoryHero';
import HeartBehind from './components/HeartBehind';
import CoFounderSection from './components/CoFounderSection';
import CoreValues from './components/CoreValues';
import StoryCTA from './components/StoryCTA';

export default function OurStory() {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Inter', sans-serif" }}>
      <Navbar />
      <StoryHero />
      <HeartBehind />
      <CoFounderSection />
      <CoreValues />
      <StoryCTA />
      <Footer />
    </div>
  );
}
